interface SEOSchemaProps {
  type: 'WebPage' | 'Article' | 'FAQPage' | 'BreadcrumbList';
  data: Record<string, unknown>;
}

export default function SEOSchema({ type, data }: SEOSchemaProps) {
  const schema = {
    '@context': 'https://schema.org',
    '@type': type,
    ...data,
  };

  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(schema) }}
    />
  );
}